import api from "./axios";

export const projectApi = {
  list: () => api.get("/projects").then((r) => r.data),
  get: (id: string) => api.get(`/projects/${id}`).then((r) => r.data),
  create: (data: {
    name: string;
    description?: string;
    startedAt?: string;
    endedAt?: string;
  }) => api.post("/projects", data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) =>
    api.patch(`/projects/${id}`, data).then((r) => r.data),
  remove: (id: string) => api.delete(`/projects/${id}`),
};
